export const INITIAL_LIMIT = 8;
export const SHIPPING_COST = 500;
export const BASE_URL = "https://nucbaz-api.vercel.app"
